import { render, staticRenderFns } from "./PresidentMessage.vue?vue&type=template&id=6519591e&scoped=true&"
import script from "./PresidentMessage.vue?vue&type=script&lang=js&"
export * from "./PresidentMessage.vue?vue&type=script&lang=js&"
import style0 from "./PresidentMessage.vue?vue&type=style&index=0&id=6519591e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6519591e",
  null
  
)

export default component.exports